var animateHeightMultiElemental = function(event, slick, currentSlide, nextSlide) {
  debugger;
  var _ = slick;
  var targetHeight = 0;
  var $activeSlides;
  if (_.options.adaptiveHeight === true && _.options.vertical === false) {
      $activeSlides = _.$slideTrack.find('.slick-active');
      // Находим наибольшую высоту у показываемых слайдов
      $activeSlides.each(function() {
          var height = $(this).outerHeight(true);
          if (targetHeight < height) {
              targetHeight = height;
          }
      });
      _.$list.animate({
          height: targetHeight
      }, _.options.speed);
  }
}

function home_slider() {
  var home_slider = $('.home_slider');
  var slides = home_slider.find('.home_slider__slide');
  var slider_next = $('<div class="slider_next"></div>');
  var direction;
  var autoplay_speed = 3000;

  // create mobile previews from main slides
  slides.each(function(index, el) {
    var slide = $(el);
    slider_next.append(html_slide_thumb({
      img: slide.data('img'),
      link: slide.data('link'),
      small: slide.data('small'),
      big: slide.data('big'),
      place: slide.data('place')
    }));
  });
  home_slider.after(slider_next);

  // create desktop next slides and content
  slides.each(function(index, el) {
    var slide = $(el);
    slide
      .append(html_slide_content({
        // small: slide.data('small'),
        big: slide.data('big'),
        place: slide.data('place')
      }), html_slide_thumb({
        img: slide.data('img'),
        link: slide.data('link'),
        // small: slide.data('small'),
        big: slide.data('big'),
        place: slide.data('place')
      }));
  });

  // init main slider
  home_slider
    .on('init', function(slick) {

      // hide loader
      $('.lds-ellipsis').fadeOut(150);

      // apply slick to mobile previews
      slider_next.slick({
        rows: 0,
        arrows: false,
        speed: 700,
        vertical: true,
        slidesToShow: 2,
        slidesToScroll: 1
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        slick.$slides.removeClass('fadeOut');

        if (Math.abs(nextSlide - currentSlide) === 1) {
          direction = (nextSlide - currentSlide > 0) ? "next" : "prev";
        } else {
          direction = (nextSlide - currentSlide > 0) ? "prev" : "next";
        }

        if (direction === 'next') {
          slick.$slides.filter('.slick-current').addClass('fadeOut');
        }

      });
      slider_next.slick('slickGoTo', 1, true);
    })
    .slick({
      rows: 0,
      // arrows: false,
      dots: true,
      autoplay: true,
      draggable: false,
      prevArrow: prevArrow('arrow-right'),
      nextArrow: nextArrow('arrow-right'),
      pauseOnHover: false,
      autoplaySpeed: autoplay_speed,
      adaptiveHeight: false,
      speed: 1100,
      cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      // switch previews in mobile view
      $('.slider_next').slick('slickGoTo', nextSlide + 1);


      // slider content animation
      if (nextSlide === 0) {
        home_slider.slick('slickSetOption', 'speed', 1360, false);
      } else {
        home_slider.slick('slickSetOption', 'speed', 1100, false);
      }

      var next_slide = slick.$slides.filter('.slick-current').next();
      var content_small = next_slide.find('.slider_content__small');
      var content_big = next_slide.find('.slider_content__big');
      var content_place = next_slide.find('.slider_content__place');

      TweenMax.from(content_small, 1.2, {
        x: '20%',
        opacity: 0,
        ease: Power2.easeOut
      });
      TweenMax.from(content_big, 1.3, {
        x: '20%',
        delay: 0.1,
        opacity: 0,
        ease: Power2.easeOut
      });
      TweenMax.from(content_place, 1.25, {
        x: '20%',
        delay: 0.2,
        opacity: 0,
        ease: Power2.easeOut
      });

      // slider preview animation
      var preview = next_slide.next().find('.slider_preview');

      TweenMax.from(preview, 1.2, {
        x: '100%',
        delay: 0.3,
        ease: Power2.easeOut
      });
    })
}